<script setup>
import { watch, inject } from "vue";
import NewsKeywordStep from "./KeywordSteps/NewsKeywordStep.vue";
import RSSKeywordStep from "./KeywordSteps/RSSKeywordStep.vue";
import SitemapKeywordStep from "./KeywordSteps/SitemapKeywordStep.vue";
import UrlKeywordStep from "./KeywordSteps/UrlKeywordStep.vue";
import BulkKeywordStep from "./KeywordSteps/BulkKeywordStep.vue";
import YoutubeKeywordStep from "./KeywordSteps/YoutubeKeywordStep.vue";

const props = defineProps(["modelValue", "step"]);
defineEmits(["update:modelValue", "next", "back", "skip"]);

const requestsSettings = inject("requestsSettings");

watch(
    [
        () => props.modelValue.language,
        () => props.modelValue.modules.autopilot.source_language,
        () => requestsSettings.value.keyword,
        () => requestsSettings.value.url,
        () => requestsSettings.value.style,
        () => requestsSettings.value.custom_style,
        () => requestsSettings.value.now_length,
        () => requestsSettings.value.generate_siloing,
    ],
    () => {
        props.modelValue.requests = [];
    }
);
</script>

<template>
    <NewsKeywordStep
        v-if="modelValue.type === 'news'"
        :modelValue="modelValue"
        @update:modelValue="$emit('update:modelValue', $event)"
        :step="step"
        @next="$emit('next')"
        @back="$emit('back')"
        @skip="$emit('skip')" />
    <RSSKeywordStep
        v-else-if="modelValue.type === 'rss'"
        :modelValue="modelValue"
        @update:modelValue="$emit('update:modelValue', $event)"
        :step="step"
        @next="$emit('next')"
        @back="$emit('back')"
        @skip="$emit('skip')" />
    <SitemapKeywordStep
        v-else-if="modelValue.type === 'sitemap'"
        :modelValue="modelValue"
        @update:modelValue="$emit('update:modelValue', $event)"
        :step="step"
        @next="$emit('next')"
        @back="$emit('back')"
        @skip="$emit('skip')" />
    <UrlKeywordStep
        v-else-if="modelValue.type === 'url'"
        :modelValue="modelValue"
        @update:modelValue="$emit('update:modelValue', $event)"
        :step="step"
        @next="$emit('next')"
        @back="$emit('back')"
        @skip="$emit('skip')" />
    <YoutubeKeywordStep
        v-else-if="modelValue.type === 'youtube'"
        :modelValue="modelValue"
        @update:modelValue="$emit('update:modelValue', $event)"
        :step="step"
        @next="$emit('next')"
        @back="$emit('back')"
        @skip="$emit('skip')" />
    <BulkKeywordStep
        v-else-if="modelValue.type === 'bulk'"
        :modelValue="modelValue"
        @update:modelValue="$emit('update:modelValue', $event)"
        :step="step"
        @next="$emit('next')"
        @back="$emit('back')"
        @skip="$emit('skip')" />
</template>
